'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'coin-front';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e3fc';
var svgPathData = 'M0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zM256 112a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 336a192 192 0 1 0 0-384 192 192 0 1 0 0 384zm24-240c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 96c0 13.3 10.7 24 24 24s24-10.7 24-24l0-96z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCoinFront = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;